export const buttonSizes = Object.freeze({
    SMALL: "SMALL_BUTTON",
    MEDIUM: "MEDIUM_BUTTON",
    LARGE: "LARGE_BUTTON",
});
